import React from 'react';

import { useIntl } from 'react-intl-next';

import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { IconButton } from '@atlaskit/button/new';
import DislikeIcon from '@atlaskit/icon/core/thumbs-down';
import LikeIcon from '@atlaskit/icon/core/thumbs-up';
import { useAnalytics } from '@atlassian/conversation-assistant-instrumentation';

import { POLLINATOR_TEST_IDS } from '../../../constants/private';

import messages from './messages';

export const LikeButton = ({
	onClick,
	isDislike,
}: {
	onClick: () => void;
	isDislike?: boolean;
}) => {
	const { sendAnalyticsEvent } = useAnalytics();
	const { formatMessage } = useIntl();

	return (
		<IconButton
			isTooltipDisabled={false}
			label={
				isDislike
					? formatMessage(messages.badResponseLabel)
					: formatMessage(messages.goodResponseLabel)
			}
			type="button"
			testId={POLLINATOR_TEST_IDS.THUMBS_UP_BUTTON}
			onClick={(_, event: UIAnalyticsEvent) => {
				sendAnalyticsEvent(
					event.update({
						actionSubjectId: isDislike ? 'badAnswerButton' : 'goodAnswerButton',
					}),
				);

				onClick();
			}}
			icon={(iconProps) =>
				isDislike ? (
					<DislikeIcon {...iconProps} color="var(--ds-icon)" />
				) : (
					<LikeIcon {...iconProps} color="var(--ds-icon)" />
				)
			}
			appearance="subtle"
			spacing="compact"
		/>
	);
};

export const LikeAnswer = ({ onClick }: { onClick: () => void }) => (
	<LikeButton onClick={onClick} />
);

export const DislikeAnswer = ({ onClick }: { onClick: () => void }) => (
	<LikeButton onClick={onClick} isDislike />
);
